import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Set target time to 24 hours from now
    const targetTime = new Date().getTime() + 24 * 60 * 60 * 1000;
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetTime - now;
      if (distance < 0) {
        clearInterval(interval);
        return;
      }
      setTimeLeft({
        hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const TimeUnit = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-19">
      <div className="bg-white rounded-lg shadow-md px-2 sm:px-4 py-2 sm:py-3 min-w-[50px] sm:min-w-[70px] border-2 border-rose-200" data-id="element-20">
        <span className="text-2xl sm:text-3xl font-bold text-rose-600" data-id="element-21">
          {String(value).padStart(2, '0')}
        </span>
      </div>
      <span className="text-[10px] sm:text-xs text-gray-600 mt-1 sm:mt-2 font-medium uppercase tracking-wide" data-id="element-22">
        {label}
      </span>
    </div>;
  return <div className="bg-gradient-to-r from-rose-50 to-orange-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 border border-rose-200 shadow-lg w-full max-w-full" data-id="element-23">
      <div className="flex items-center justify-center gap-2 mb-3 sm:mb-4" data-id="element-24">
        <ClockIcon className="w-4 h-4 sm:w-5 sm:h-5 text-rose-500 flex-shrink-0" data-id="element-25" />
        <h3 className="text-sm sm:text-lg font-bold text-gray-800 text-center" data-id="element-26">
          La oferta termina en:
        </h3>
      </div>
      <div className="flex justify-center gap-2 sm:gap-3" data-id="element-27">
        <TimeUnit value={timeLeft.hours} label="Horas" data-id="element-28" />
        <div className="text-2xl sm:text-3xl font-bold text-rose-500 self-start mt-2 sm:mt-3" data-id="element-29">
          :
        </div>
        <TimeUnit value={timeLeft.minutes} label="Minutos" data-id="element-30" />
        <div className="text-2xl sm:text-3xl font-bold text-rose-500 self-start mt-2 sm:mt-3" data-id="element-31">
          :
        </div>
        <TimeUnit value={timeLeft.seconds} label="Segundos" data-id="element-32" />
      </div>
    </div>;
}